export default {
  "auth-layout": () => import("/app/layouts/auth-layout.vue"),
  default: () => import("/app/layouts/default.vue"),
  "front-layout": () => import("/app/layouts/front-layout.vue"),
  "home-layout": () => import("/app/layouts/home-layout.vue")
}